// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n'
import utils from '@/utils/utils'

import APIPath from "@/utils/APIPath";
import storage from "@/utils/storage";
import httpClient from "@/utils/httpClient";
import store from "@/utils/store";
import * as config from '@/config/config'
import i18nFile from '@/i18n/index'
import router from '@/router'
import enlocale from 'element-ui/lib/locale/lang/en'
import zhlocale from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'
// // swiper
// import "swiper/swiper-bundle.min.css";

Vue.config.productionTip = false


// import '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont/iconfont.js'
import '@/style/theme/index.css'
import '@/style/comm.scss'
import filters from "@/utils/filters";

ElementUI.Dialog.props.closeOnClickModal.default = false

Vue.config.productionTip = false
Vue.use(ElementUI, {locale: zhlocale});

Vue.prototype.utils = utils
Vue.prototype.httpClient = httpClient
Vue.prototype.APIPath = APIPath
Vue.prototype.storage = storage
Vue.prototype.config = config
Vue.prototype.eventBus = new Vue()

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
Vue.use(VueAwesomeSwiper /* { default options with global component } */)

Vue.use(VueI18n) ;

const i18n = new VueI18n({
  locale: storage.getLang(),    // 语言标识, 通过切换locale的值来实现语言切换,this.$i18n.locale
  messages: {
    'zh-CN': {
      lang: require('./i18n/zh').lang,
      ...zhlocale
    },   // 中文语言包
    'en-US': {
      lang: require('./i18n/en').lang,
      ...enlocale
    }// 英文语言包
  }
})

locale.i18n((key, value) => i18n.t(key, value)) //为了实现element插件的多语言切换
i18nFile.setI18n(i18n)

// 添加全局filter
Object.keys(filters).map(v => {
  Vue.filter(v, filters[v])
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js